import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import getItineraryEndpointPath from '@/src/utils/rtkQuery/getItineraryEndpointPath'

type BookingJourneyDetail = {
    journeyId: string | null
    bookingStatus: string
    airlinePnr: string | null
    gdsPnr: string | null
    ticketNumber: string[] | null
}

type FetchBookingDetailsParams = {
    bookingId: string
}

export const fetchBookingDetailsApi = createApi({
    reducerPath: 'fetchBookingDetailsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => setCommonHeaders(headers)
    }),
    endpoints: builder => ({
        fetchBookingDetails: builder.query<BookingJourneyDetail[], FetchBookingDetailsParams>({
            query: ({ bookingId }) => ({
                url: getItineraryEndpointPath(bookingId, `/itin/fetch/booking/details/${bookingId}`),
                method: 'POST'
            })
        })
    })
})

export const { useFetchBookingDetailsQuery, useLazyFetchBookingDetailsQuery } = fetchBookingDetailsApi

export default fetchBookingDetailsApi
